import { GenAILogo, ArrowBackIcon } from '@/components/icons';
import useStyles from './HeaderLeft.styles';

import type { Screen } from '@/types';

interface HeaderLeftProps {
  screen: Screen;
  showBackButton: boolean;
  mobileTitle: string;
  onBack: () => void;
}

const TaglineContent = () => <>AI-Powered Creation</>;

export const HeaderLeft = ({
  screen,
  showBackButton,
  mobileTitle,
  onBack,
}: HeaderLeftProps) => {
  const classes = useStyles();

  return (
    <div className={classes.left}>
      {/* Back button - CSS hides on desktop */}
      {showBackButton && (
        <button
          type="button"
          className={classes.backButton}
          onClick={onBack}
          title="Go back"
          aria-label="Go back"
        >
          <ArrowBackIcon />
        </button>
      )}
      {/* GenAI Studio Logo - hidden on mobile for non-library screens */}
      <GenAILogo
        className={`${classes.logo} ${
          screen !== 'library' ? classes.logoHiddenOnMobile : ''
        }`}
      />
      <div className={classes.titleGroup}>
        {/* Desktop: Always show "GenAI Studio" */}
        <h1 className={`${classes.title} ${classes.titleDesktop}`}>
          GenAI Studio
        </h1>
        {/* Mobile: Show screen-specific title */}
        <h1 className={`${classes.title} ${classes.titleMobile}`}>
          {mobileTitle}
        </h1>

        {/* Desktop: Divider and tagline always visible */}
        <div className={`${classes.titleDivider} ${classes.taglineDesktop}`} />
        <span className={`${classes.tagline} ${classes.taglineDesktop}`}>
          <TaglineContent />
        </span>

        {/* Mobile: Divider and tagline only on library screen (hidden on small mobile via CSS) */}
        {screen === 'library' && (
          <>
            <div
              className={`${classes.titleDivider} ${classes.taglineMobile}`}
            />
            <span className={`${classes.tagline} ${classes.taglineMobile}`}>
              <TaglineContent />
            </span>
          </>
        )}
      </div>
    </div>
  );
};
